import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-029e55f7")

_pushScopeId("data-v-029e55f7")
const _hoisted_1 = { class: "ml-2.5 text-gray-lp-300 mr-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
    return (_openBlock(), _createBlock("div", {
      class: ["flex flex-row mt-2", _ctx.customClass],
      key: index,
      onClick: ($event: any) => (_ctx.onChange(option))
    }, [
      _createVNode("input", {
        type: "radio",
        name: _ctx.name,
        value: option,
        checked: _ctx.modelValue === option,
        onChange: ($event: any) => (_ctx.onChange(option)),
        class: "w-5 h-5"
      }, null, 40, ["name", "value", "checked", "onChange"]),
      _createVNode("label", _hoisted_1, _toDisplayString(_ctx.labels[index]), 1)
    ], 10, ["onClick"]))
  }), 128))
})